module.exports = __webpack_public_path__ + "img/3.2.3.9c6ee8b1.png";